'use strict';
import has from 'lodash/has';
import toLower from 'lodash/toLower';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {observeNewOnScope, observeOnAttributes} from '../../core-utilities/rx-utils';
import {DomainImage} from '../components/DomainImage';

DomainImageDirective.$inject = [
];

// Supports a "placeholder" attribute that should contain an alternate image source;
export function DomainImageDirective() {
  return {
    restrict: 'A',
    scope: {
      file: '=domainImage',
      targetWidth: '=?',
      targetHeight: '=?',
      cropTarget: '=?',
      domainImageLoaded: '=?',
      domainImageLoading: '=?'
    },
    link: function (scope, tElement, tAttrs) {

      // initialize state
      scope.domainImageLoaded = false;
      scope.domainImageLoading = true;
      scope.showPlaceholder = false;
      scope.placeholder = null;

      scope.$evalAsync(initLink);

      function initLink() {
        if (tElement[0].tagName !== 'IMG')
          throw new Error('domain-image directive must be applied to an img tag!');

        Observable.merge(
          observePlaceholder(),
          observeFile(),
        ).subscribe(data =>
          /* Approximate setState(); replace with setState in React version */
          scope.$evalAsync(() => {
            if (has(data, 'source'))
              updateSource(data.source);
            if (has(data, 'domainImageLoaded'))
              scope.domainImageLoaded = data.domainImageLoaded;
            if (has(data, 'domainImageLoading'))
              scope.domainImageLoading = data.domainImageLoading;
            if (has(data, 'showPlaceholder'))
              scope.showPlaceholder = data.showPlaceholder;
            if (has(data, 'placeholder'))
              scope.placeholder = data.placeholder;

            if (scope.showPlaceholder && scope.placeholder) {
              updateSource(scope.placeholder);
            }
          })
        );

        function observeFile() {
          return observeNewOnScope(scope, () => getId(scope.file))
            .distinctUntilChanged()
            .map(() => scope.file)
            .switchMap(file => {
              let type = typeof tAttrs.domainImageSize !== 'undefined' ? toLower(tAttrs.domainImageSize) : 'tb';
              return DomainImage.onNewFileId(file, type, scope);
            });
        }

        function observePlaceholder() {
          return observeOnAttributes(tAttrs, 'placeholder')
            .mergeMap(placeholder => placeholder ? Observable.of({placeholder}) : Observable.empty());
        }

        function updateSource(url) {
          tAttrs.$set('src', url || null);
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/files/directives/DomainImageDirective.js